<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="inline-oil">
    <!-- <h5>油卡余额不足</h5> -->
    <table class="dataintable">

      <tr class="tab_header">
        <td>序号</td>
        <td class="short0 left">账号</td>
        <td class="short0 left">姓名</td>
        <td class="short0">合同到期日期</td>
        <td class="short0">剩余天数</td>
      </tr>
      <tr v-for="(item, index) in list_ld_ht" :key="index">
        <td>{{ item.row_num }}</td>
        <td class="short0 left">{{ item.u_no }}</td>
        <td class="short0 left">{{item.u_name}}</td>
        <td class="short0">{{ item.ht_end }}</td>
        <td class="short0">{{ item.ht_last }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import api from '@/utils/type.js'

  import {
    Sel_page_and_length,
    Method_EasyAdd
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "oil",
    data() {
      return {
        element_loading: false,

        list_ld_ht: [],
        list_sy_ht: []




      };
    },
    created: function() {
      console.log('油卡 组件 创建');
      // this.loaddata();
    },
    mounted: function() {
      console.log('油卡 组件 mounted');
      this.loaddata();
    },
    activated: function() {
      console.log('油卡 组件激活时调用 激活');

    },
    methods: {
      loaddata: function() {
        this.element_loading = true;
        this.list_ld_ht = [];

        let r = (Math.random() + '').substring(0, 8);

        this.$post(
          api.http_method, Sel_page_and_length('exp_userhetong',1, 100)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          if(res.length>0){
            let t=res[0];
            for(let i=0;i<t.length;i++){
              let o={};

              o=t[i];
              o.row_num=i+1;
              this.list_ld_ht.push(o);
            }
          }

          console.log(this.list_ld_ht);

        });
      },
    }


  }
</script>

<style scoped="scoped">
  .inline-oil {
    display: inline-block;
    min-height: calc(100vh - 120px);
    max-height: calc(100vh - 120px);
    overflow: auto;
    vertical-align: top;
  }

  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
</style>
